export default __webpack_public_path__ + "static/media/medal.32e3dd6a.svg";